<template>
    <div class="fw-renew">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div class="renews">
            <div class="renew-user" v-for="item in list">
              <div class="ru-l">
                  <span class="s">{{item.deptName}}</span>
                  <span class="z">PLUS:{{item.plusName}}</span>
                  <span class="x">到期时间: {{item.expireDate}}</span>
              </div>
                <div class="ru-r" v-if="item.deptType==2">
                    <span class="hb" @click="toPoster">海报</span>
                    <span class="xf" @click="toSvd(item)">续费</span>
                </div>
            </div>
        </div>
        <van-popup v-model="showPoster">
            <div id="imageWrapper1">
                <div class="content_container">
                    <vue-canvas-poster v-if="!posterImg" :widthPixels="595" :heightPixels="842" :painting="painting"
                                       @success="success" @fail="fail">
                    </vue-canvas-poster>
                    <van-image :src="posterImg" id="mypic" class="hb-img" crossOrigin="anonymous"/>
                </div>
            </div>
            <!--      <div style="background-color:#484848;opacity:1;display: block;">-->
            <!--        <van-button type="danger" style="width: 100%;height: 38px;line-height: 38px" @click="toSaveImage(posterImg)">保存图片</van-button>-->
            <!--      </div>-->
        </van-popup>
    </div>
</template>

<script>
    import {getCookie,} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                title: '门店续费',
                fwUser: {},
                deptId: '',
                token: '',
                list:[],

                showPoster: false,
                posterImg: '',//生成的海报
                painting: {
                    views: []
                },
                touxiang: '',
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.getRenewDepts()
        },
        methods: {
            async getRenewDepts() {
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/fw/getRenewDepts", data)
                this.list=res.list
            },
            toSvd(item){
                this.$router.push('/svd?deptId='+item.id);
            },
            async toPoster() {
                this.showPoster = true
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/fw/getUserPoster", data)
                var pmName = res.pmName == null ? '未开通' : res.plusName
                var touxiang=''
                    if (res.sex == 1) {
                        touxiang = require('./../../assets/nan.png')
                    } else {
                        touxiang = require('./../../assets/nv.png')
                    }
                this.painting = {
                    position: 'relative',
                    width: '595px',
                    height: '842px',
                    background: '#FFFFFF',
                    views: [
                        {
                            type: 'image',
                            url: res.qrCode,
                            css: {
                                position: 'absolute',
                                right: '26%',
                                top: '28%',
                                color: '#000',
                                background: '#fff',
                                width: '288px',
                                height: '288px',
                                borderWidth: '40px',
                                borderColor: '#fff',
                            },
                        },
                        {
                            type: "text",
                            text: "- 长按识别查看 -",
                            css: {
                                top: "63%",
                                right: '25%',
                                width: "300px",
                                maxLines: 1,
                                textAlign: "center",
                                fontSize: "32px",
                                color: "#D3D3D3",
                            },
                        },
                        {
                            type: 'image',
                            url: touxiang,
                            css: {
                                position: 'absolute',
                                top: '9%',
                                left: '22%',
                                color: '#000',
                                background: '#fff',
                                width: '80px',
                                height: '80px',
                                borderRadius: '60px',
                            },
                        },
                        {
                            type: "text",
                            text: res.userName,
                            css: {
                                top: "9%",
                                left: "40%",
                                width: "250px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "32px",
                                color: "#8B8A8A",
                            },
                        },
                        {
                            type: "text",
                            text: "PLUS: " + pmName,
                            css: {
                                top: "15%",
                                left: "41%",
                                height: "30px",
                                padding: "5px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "left",
                                fontSize: "20px",
                                color: "#8B8A8A",
                                background: "#eeeeef",
                            },
                        },
                        {
                            type: 'image',
                            url: require('./../../assets/md.png'),
                            css: {
                                position: 'absolute',
                                top: '76%',
                                left: '28.5%',
                                color: '#000',
                                background: '#fff',
                                width: '58px',
                                height: '58px',
                            },
                        },
                        {
                            type: "text",
                            text: res.deptName,
                            css: {
                                top: "76%",
                                left: "38%",
                                width: "200px",
                                height: "30px",
                                lineHeight: "25px",
                                maxLines: 1,
                                textAlign: "center",
                                fontSize: "45px",
                                color: "#8B8A8A",
                            },
                        },
                    ],
                }
            },

            // 保存图片到本地
            toSaveImage(img) {
            },

            // 海报生成
            success(src) {
                this.posterImg = src
            },

            //赋值
            handleUpdateBg(row) {
                this.posterImg = ''
                this.painting.views[0].url = row.qrUrl
            },

            fail() {

            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-renew {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
        padding-bottom: 49px;
        background-color: #FAFAFA;
    }
    .renews{

    }
    .renew-user{
      display: flex;
      flex-direction: row;
      align-items: center;
      border-bottom: #e5e5e5 solid 1px;
    }
    .ru-l{
        width: 60%;
        display: flex;
        flex-direction: column;
        padding: 8px 10px;
    }

    .ru-l .s{
        padding: 12px 5px;
        font-size: 15px;
    }
    .ru-l .z{
        padding: 5px;
        font-size: 12px;
    }
    .ru-l .x{
        padding: 5px;
        font-size: 12px;
    }
    .ru-r{
        width: 40%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .ru-r .hb{
      border: #e5e5e5 solid 1px;
      padding: 5px 10px;
      font-size: 13px;
    }
    .ru-r .xf{
      border: #e5e5e5 solid 1px;
      padding: 5px 10px;
      font-size: 13px;
      margin-left: 10px;
      color: #ffffff;
      background-color: #785F57;
    }
    .content_container {
        width: 256px;
        height: 356px;
        overflow: hidden;
        margin: auto;
        background-size: 100% 100%;
    }

    .hb-img {
        width: 256px;
        height: 356px;
        background-size: 100% 100%;
    }


</style>